<div class="promoter__profile" *ngIf="!loading">
  <div class="settings d-flex flex-row">
    <mat-icon class="edit-icon" [matMenuTriggerFor]="menu">more_vert</mat-icon>
    <mat-menu xPosition="before" #menu="matMenu">
      <button mat-menu-item (click)="showEdit()">{{ 'PERSONAL_PROFILE.EDIT_PROFILE' | translate }}</button>
    </mat-menu>
  </div>
  <div class="promoter__wrapper" [formGroup]="personalProfileForm">
    <div class="d-flex flex-row justify-content-between">
      <div class="d-flex flex-row" style="align-items: self-end;">
        <input class="hidden" type="text" formControlName="profileImagePath"/>
        <input (change)="onFileSelected($event)"
               class="open-file hidden"
               type="file" id="openFile"
               #openFile name="openFile"
               (click)="onFileInputClick($event)"
               accept="image/png, image/jpg, image/jpeg"/>
        <img [src]="this.imagePath" alt="profile-picture">
        <div *ngIf="!enableEdit" class="profile-info">
          <h5 class="title"><span>{{personalProfileForm.controls['firstName'].value}}
            </span><span>{{personalProfileForm.controls['lastName'].value}}</span></h5>
          <div class="promoter__profile__role">
            <img src="assets/images/icons/the-crown.svg">
            <span *ngIf="isAdvertiser">General Manager  </span>
            <a class="user__link" [routerLink]="['/promoter/company-profile']">{{companyName}}</a>
          </div>
        </div>
        <div *ngIf="enableEdit" class="profile-edit">
          <div (click)="openAddImage()" class="d-flex flex-row">
            <mat-icon>edit</mat-icon>
            <p class="m-0">{{ 'PERSONAL_PROFILE.CHANGE_PICTURE' | translate }}</p>
          </div>
          <!-- <label class="pictureError" *ngIf="pictureIsToBig">{{ 'VENUES.PICTURE_IS_TO_BIG' | translate }}</label> -->
          <label class="pictureError" *ngIf="pictureIsWrongFormat">{{ 'VENUES.PICTURE_IS_WRONG_FORMAT' |translate}}</label>
        </div>
      </div>

      <div style="width: 50%; padding-left: 15px;">
        <label class="mt-0" for="accountTier">{{ 'LOGIN.ACCOUNT_TIER' | translate }}</label>
        <input *ngIf="isAdvertiser" disabled type="text" id="accountTier" [value]="'General Manager'"
               name="accountTier">
      </div>
    </div>
    <div *ngIf="enableEdit" class="d-flex flex-row justify-content-between" style="padding-bottom: 32px;">
      <div style="width: 23%;">
        <div class="d-flex flex-row label-info">
          <label style="border-bottom: none;" for="firstName">{{ 'PERSONAL_PROFILE.NAME' | translate }} *
            <i *ngIf="personalProfileForm.controls.firstName.invalid && (personalProfileForm.controls.firstName.dirty || personalProfileForm.controls.firstName.touched)">
              <i *ngIf="personalProfileForm.controls.firstName.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.REQUIRED' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i>
            </i>
          </label>
          <mat-icon class="edit-input-icon" style="padding-top: 33px;">edit</mat-icon>
        </div>
        <input type="text" formControlName="firstName" name="firstName" id="firstName">
      </div>
      <div style="width: 23%;">
        <div class="d-flex flex-row label-info">
          <label style="border-bottom: none;" for="lastName">{{ 'PERSONAL_PROFILE.SURNAME' | translate }} *
            <i *ngIf="personalProfileForm.controls.lastName.invalid && (personalProfileForm.controls.lastName.dirty || personalProfileForm.controls.lastName.touched)">
              <i *ngIf="personalProfileForm.controls.lastName.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.REQUIRED' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i>
            </i>
          </label>
          <mat-icon class="edit-input-icon" style="padding-top: 33px;">edit</mat-icon>
        </div>
        <input type="text" formControlName="lastName" name="lastName" id="lastName">
      </div>
      <div style="width: 48%;">
      </div>
    </div>
    <div class="d-flex flex-row justify-content-between" [style.margin-top]="enableEdit?'0px':'32px'"
         style="padding-bottom: 32px;">
      <div style="width: 23%;">
        <div class="d-flex flex-row label-info">
          <label class="input-label" for="birthday">{{ 'LOGIN.BIRTHDAY' | translate }}
            <i *ngIf="personalProfileForm.controls.dateOfBirth.invalid && (personalProfileForm.controls.dateOfBirth.dirty || personalProfileForm.controls.dateOfBirth.touched)">
              <i *ngIf="personalProfileForm.controls.dateOfBirth.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.REQUIRED' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i>
            </i>
            <i *ngIf="enableEdit">*</i>
          </label>
          <mat-icon *ngIf="enableEdit" class="edit-input-icon" style="padding-top: 5px;">edit
          </mat-icon>
        </div>
        <div class="cal-wrp">
          <label *ngIf="!enableEdit" class="simple-label">{{dateOfBirth}}</label>
          <div class="btnCal-wrp" *ngIf="enableEdit">
            <p-calendar dateTimeMask formControlName="dateOfBirth" [maxDate]="maxDate"  [showIcon]="true"
                                        placeholder="mm/dd/yyyy"></p-calendar>
          </div>
        </div>
      </div>
      <div style="width: 23.5%;">
        <div class="d-flex flex-row label-info">
          <label class="input-label" for="company">{{ 'LOGIN.COMPANY' | translate }}</label>
          <mat-icon *ngIf="enableEdit" class="edit-input-icon"></mat-icon>
        </div>
        <input disabled type="text" id="company" [value]="companyName" name="company">
      </div>
      <div style="width: 22.5%;">
        <div class="d-flex flex-row label-info">
          <label class="input-label" for="email">{{ 'LOGIN.EMAIL' | translate }}</label>
          <mat-icon *ngIf="enableEdit" class="edit-input-icon"></mat-icon>
        </div>
        <input disabled type="text" id="email" [value]="email" name="email">
      </div>
      <div style="width: 23%;">
        <div class="d-flex flex-row label-info">
          <label class="input-label" for="phone">{{ 'LOGIN.PHONE' | translate }}
            <i *ngIf="enableEdit">*
              <i *ngIf="personalProfileForm.controls.phone.invalid && (personalProfileForm.controls.phone.dirty || personalProfileForm.controls.phone.touched)">
                <i *ngIf="personalProfileForm.controls.phone.errors?.['required']">
                    <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                        pTooltip="{{ 'INFO.REQUIRED' | translate }}" tooltipStyleClass="test"
                        tooltipPosition="top"></i>
                </i>
                <i *ngIf="personalProfileForm.controls.phone.errors?.['pattern']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.PHONE_PATTERN' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i>
              </i>
            </i>
          </label>
          <mat-icon *ngIf="enableEdit" class="edit-input-icon">edit</mat-icon>
        </div>
        <input type="text" formControlName="phone" name="phone" id="phone">
      </div>
    </div>
    <div *ngIf="enableEdit" class="d-flex flex-row save-cancel-btn-container">
      <button class="mat-bakcground-primary mat-raised-button mat-raised-save-button"
      [disabled]="personalProfileForm.controls.firstName.invalid || personalProfileForm.controls.lastName.invalid || personalProfileForm.controls.dateOfBirth.invalid || personalProfileForm.controls.phone.invalid" (click)="save()">{{ 'SAVE_CHANGES' | translate }}</button>
      <button class="mat-raised-button mat-raised-cancel-button" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
  </div>
</div>
<div *ngIf="loading" class="row info">
  <mat-spinner class="api-data-spinner load-info-spinner"></mat-spinner>
</div>
